module.exports = __webpack_public_path__ + "static/media/ic_facebook.3018d577.svg";